module.exports = __webpack_public_path__ + "img/eating contest.4511c7ab.png";